import { COMPLIANCE_REVIEWS_LOCAL_STATUS } from "@/constants";
import { COMPLIANCE_REVIEW_STATUS } from "@/constants/complianceReview";

export default {
  complianceReviewList(state) {
    return state.complianceReviewList.data;
  },

  complianceReviewListLoading(state) {
    return (
      state.complianceReviewList.status ===
      COMPLIANCE_REVIEWS_LOCAL_STATUS.LOADING
    );
  },

  complianceReviewItem(state) {
    return state.complianceReviewItem.data;
  },

  isComplianceReviewItemResolved(state) {
    return (
      state.complianceReviewItem.data.status ===
      COMPLIANCE_REVIEW_STATUS.COMPLETED
    );
  }
};
